import React, { FunctionComponent, useEffect, useMemo, useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { MdCheck } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'

import ICancelTripImpl from 'modules/lotesSolicitados/domain/usecases/CancelTripImpl'
import IEndTripImpl from 'modules/lotesSolicitados/domain/usecases/EndTripImpl'
import { formatBreadCrumb } from 'shared/components/BasePage/formatBreadCrumb'
import Button from 'shared/components/Button'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import Modal from 'shared/components/Modal'
import Pagination from 'shared/components/Pagination'
import { Select } from 'shared/components/Select'
import SnackBar from 'shared/components/SnackBar'
import Text from 'shared/components/Text'
import IFindByCodigoOcOuLoteSolicitadoIdImpl from 'shared/modules/ordemCarregamento/domain/usecases/FindByCodigoOcOuLoteSolicitadoIdImpl'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'

import ILoteSolicitado from '../../domain/entities/LoteSolicitado'
import IFindAllImpl from '../../domain/usecases/FindAllImpl'
import { useFiltros } from '../../hooks/filtros'
import LoteSolicitadoCard from './components/LoteSolicitadoCard'
import {
  BreadCrumb,
  ContainerCards,
  ContainerCenter,
  Content,
  Title,
  StyledCheck,
  ContainerIcons,
} from './styles'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import ISendSmsImpl from 'modules/lotesSolicitados/domain/usecases/SendSmsImpl'
import Drawer from './components/Drawer'
import ModalWaitForNotification from '../components/ModalWaitForNotification'
import { ELockOCMessageTypes } from '../utils/ELockOCMessage'
import ModalSemCadencia from '../components/ModalSemCadencia'
import ModalReprovadoGr from '../components/ModalReprovadoGr'
import ModalAguardandoValidacao from '../components/ModalAguardandoValidacao'
import IGetDocumentosImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentosImpl'
import IGetAllDocumentosPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetAllDocumentosPdfImpl'
import IGetDocumentoPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPdfImpl'
import IGetDocumentoPedagioPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPedagioPdfImpl'

type TProps = {
  findAll: IFindAllImpl
  cancelTrip: ICancelTripImpl
  endTrip: IEndTripImpl
  sendSms: ISendSmsImpl
  findByCodigoOcOuLoteSolicitadoId: IFindByCodigoOcOuLoteSolicitadoIdImpl
  getDocumentos: IGetDocumentosImpl
  getAllDocumentosPdf: IGetAllDocumentosPdfImpl
  getDocumentoPdf: IGetDocumentoPdfImpl
  getDocumentoPedagioPdf: IGetDocumentoPedagioPdfImpl
}

const sorts = ['MAIS RECENTE', 'MAIS ANTIGO']

const ListLotesSolicitados: FunctionComponent<TProps> = ({
  findAll,
  endTrip,
  cancelTrip,
  sendSms,
  findByCodigoOcOuLoteSolicitadoId,
  getDocumentos,
  getAllDocumentosPdf,
  getDocumentoPdf,
  getDocumentoPedagioPdf,
}) => {
  const { destinoCompleto, origemCompleta, nomeOuCpf, placa, cte } =
    useFiltros()
  const { frotistaId } = useFrotista()
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [lotes, setLotes] = useState<ILoteSolicitado[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [open, setOpen] = useState(false)
  const [messages, setMessages] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [sort, setSort] = useState('')
  const [countFilters, setCountFilters] = useState(0)
  const [loteSolicitadoId, setLoteSolicitadoId] = useState(0)
  const [modalAlertType, setAlertType] = useState<ELockOCMessageTypes>()
  const [smsConfig, setSmsConfig] = useState(false)
  const [telefone, setTelefone] = useState('')
  const history = useHistory()
  const [openDrawer, setOpenDrawer] = useState(false)
  const [loteDetalhado, setLoteDetalhado] = useState<ILoteSolicitado>(
    {} as ILoteSolicitado,
  )

  useEffect(() => {
    const init = async () => {
      setLoading(true)
      try {
        let totalFilters = 0

        if (destinoCompleto && destinoCompleto.id) totalFilters += 1
        if (origemCompleta && origemCompleta.id) totalFilters += 1
        if (nomeOuCpf) totalFilters += 1
        if (placa) totalFilters += 1
        if (cte) totalFilters += 1

        setCountFilters(totalFilters)

        const response = await findAll.execute({
          page: currentPage || 1,
          destino:
            destinoCompleto.nome &&
            `${destinoCompleto.nome} ${destinoCompleto.uf_estado}`,
          origem:
            origemCompleta.nome &&
            `${origemCompleta.nome} ${origemCompleta.uf_estado}`,
          cidadeOrigemIBGE: origemCompleta?.ibge,
          cidadeDestinoIBGE: destinoCompleto?.ibge,
          motorista: nomeOuCpf,
          cte,
          placa,
          sort,
          frotistaId: frotistaId,
        })
        const { data, total } = response
        setLotes(data)
        setTotalRecords(total)
        setLoading(false)
      } catch (error) {
        setError(true)
        setLoading(false)
      }
    }

    init()
  }, [
    findAll,
    currentPage,
    destinoCompleto,
    nomeOuCpf,
    cte,
    origemCompleta,
    placa,
    sort,
    frotistaId,
  ])

  const setLoadingCard = (loading: boolean) => {
    setLoading(loading)
  }
  const setOpenSnackbar = (open: boolean) => {
    setOpen(open)
  }
  const setMessagesSnackbar = (messages: string) => {
    setMessages(messages)
  }
  const setAlertTypeFn = (status: ELockOCMessageTypes) => {
    setAlertType(status)
  }
  const handleChangeSelect = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    if (sorts.includes(event.target.value as string)) {
      setSort(event.target.value as string)
    }
  }

  const cardLotesSolicitados = useMemo(() => {
    return (
      lotes &&
      lotes.map(value => (
        <Grid key={value.id} item xs={12}>
          <LoteSolicitadoCard
            lote={value}
            findByCodigoOcOuLoteSolicitadoId={findByCodigoOcOuLoteSolicitadoId}
            cancelTrip={cancelTrip}
            endTrip={endTrip}
            setLoading={setLoadingCard}
            setOpen={setOpenSnackbar}
            setMessages={setMessagesSnackbar}
            setOpenModal={setOpenModal}
            setLoteSolicitadoId={setLoteSolicitadoId}
            setSmsConfig={setSmsConfig}
            setTelefone={setTelefone}
            setOpenDrawer={setOpenDrawer}
            setLoteDetalhado={setLoteDetalhado}
            setAlertType={setAlertTypeFn}
          />
        </Grid>
      ))
    )
  }, [lotes, findByCodigoOcOuLoteSolicitadoId, cancelTrip, endTrip])

  const closeDrawer = () => {
    if (openDrawer) {
      setOpenDrawer(false)
    }
  }

  return (
    <>
      <Content onClick={() => closeDrawer()}>
        <BreadCrumb>
          <Title>
            {formatBreadCrumb('Ofertas de cargas / Ofertas solicitadas')}
          </Title>
          <ContainerIcons>
            <FaFilter color={colors.green} />
            <Button
              aria-label="btn-lote-filter-page"
              size={'small'}
              fontColor={colors.blue}
              color={'transparent'}
              onClick={() => {
                history.push('/lotes-solicitados/filtros')
              }}
            >
              {countFilters ? `FILTRAR(${countFilters})` : 'FILTRAR'}
            </Button>
          </ContainerIcons>
        </BreadCrumb>
        {loading ? (
          <LoadingBackdrop open={loading} color={colors.green} />
        ) : error ? (
          <ContainerCenter>
            Não foi possível carregar as ofertas solicitadas, por favor tente
            novamente em alguns minutos.
          </ContainerCenter>
        ) : (
          <>
            <ContainerCards>
              <Grid container spacing={4}>
                <Grid
                  container
                  item
                  xs={12}
                  alignItems="flex-end"
                  justifyContent="flex-end"
                >
                  <Select
                    id="select-lotes-solicitados-id"
                    name="ordernar-lotes-solicitados"
                    label="Ordenar por"
                    value={sort}
                    options={sorts}
                    onChange={handleChangeSelect}
                  />
                </Grid>
                {lotes.length === 0 ? (
                  <ContainerCenter>Nenhuma oferta solicitada.</ContainerCenter>
                ) : (
                  cardLotesSolicitados
                )}
              </Grid>
            </ContainerCards>
          </>
        )}
        <Pagination
          currentPage={currentPage}
          recordsPerPage={15}
          totalRecords={totalRecords}
          setCurrentPage={setCurrentPage}
        />
      </Content>

      <SnackBar
        open={open}
        message={messages}
        setOpen={setOpen}
        severity={'error'}
      />

      <Modal
        openModal={openModal}
        size="small"
        onCloseModal={() => {
          setOpenModal(false)
          window.location.reload()
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
          style={{ textAlign: 'center', height: '80%' }}
        >
          <Grid item md={12}>
            <StyledCheck />
          </Grid>

          <Grid item md={12}>
            <Text weight="700" size={dimensions?.fontSize?.largex2}>
              Viagem finalizada/cancelada com sucesso!
            </Text>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Button
            color={colors.orange}
            style={{ height: 32, width: 122 }}
            onClick={() => {
              setOpenModal(false)
              window.location.reload()
            }}
          >
            <MdCheck />
            OK
          </Button>
        </Grid>
      </Modal>

      <ModalReprovadoGr
        openModal={modalAlertType === ELockOCMessageTypes.REPROVADO_GR}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      />
      <ModalSemCadencia
        openModal={modalAlertType === ELockOCMessageTypes.SEM_CADENCIA}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      />
      <ModalAguardandoValidacao
        loteId={loteSolicitadoId}
        openModal={modalAlertType === ELockOCMessageTypes.AGUARDANDO_VALIDACAO}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
        sendSms={sendSms}
        telefone={telefone}
      />
      <ModalWaitForNotification
        openModal={modalAlertType === ELockOCMessageTypes.WAIT_FOR_NOTIFICATION}
        setAlertType={() => setAlertType(ELockOCMessageTypes.NENHUM)}
        smsConfig={smsConfig}
      />

      {openDrawer && (
        <Drawer
          lote={loteDetalhado}
          setOpenDrawer={setOpenDrawer}
          getDocumentos={getDocumentos}
          getAllDocumentosPdf={getAllDocumentosPdf}
          getDocumentoPdf={getDocumentoPdf}
          getDocumentoPedagioPdf={getDocumentoPedagioPdf}
        />
      )}
    </>
  )
}

export default ListLotesSolicitados
